<template>
  <div class="caption">
    <svg
      v-resize="onResize"
      ref="svg"
      :viewBox="`0 0 ${chartWidth} ${chartHeight}`"
      class="d-block mx-auto"
      :style="{ width: '100%', 'max-width': this.chartMaxWidth }"
    >
      <g>
        <path
          v-for="feature in geoData.features"
          :key="feature.properties.admin_1_code"
          :d="path(feature)"
          :style="{
            fill: percentageDataMap.get(feature.properties.admin_1_code).color
          }"
          class="path"
        ></path>
      </g>
      <g>
        <text
          v-for="feature in geoData.features"
          :key="feature.properties.admin_1_code"
          :y="path.centroid(feature)[1]"
          text-anchor="middle"
        >
          <tspan v-if="!simplified" :x="path.centroid(feature)[0]">
            {{
              $t(
                `filters.demographics.region.options.${feature.properties.admin_1_code}`
              )
            }}
          </tspan>
          <tspan
            :x="path.centroid(feature)[0]"
            :dy="simplified ? '0.32em' : '1em'"
          >
            {{
              percentageDataMap.get(feature.properties.admin_1_code).formated
            }}
          </tspan>
        </text>
      </g>
    </svg>
  </div>
</template>

<script>
import { mdiMap } from "@mdi/js";
import geoData from "@/assets/data/morocco_admin_1.json";
import { mapGetters } from "vuex";
import { format } from "d3-format";
import { geoMercator, geoPath } from "d3-geo";
import { scaleLinear } from "d3-scale";
import { interpolateHcl } from "d3-interpolate";
export default {
  props: { showLikelyhood: { type: Boolean, required: true } },
  data() {
    return {
      geoData,
      ratio: 1,
      chartWidth: 600,
      chartMaxWidth: 600,
      margin: 24,
      icon: {
        region: mdiMap
      }
    };
  },
  computed: {
    ...mapGetters([
      "filteredCount",
      "filteredData",
      "filteredDemographicData",
      "filteredDataNoLP"
    ]),
    chartHeight() {
      return Math.round(this.chartWidth / this.ratio);
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    path() {
      const projection = geoMercator().fitExtent(
        [
          [this.margin, this.margin],
          [this.chartWidth - this.margin, this.chartHeight - this.margin]
        ],
        this.geoData
      );
      return geoPath().projection(projection);
    },
    getRegionData() {
      return this.filteredDemographicData("region");
    },
    color() {
      return scaleLinear()
        .domain([0, 1])
        .range([
          this.$vuetify.theme.themes.light.secondary,
          this.$vuetify.theme.themes.light.section1
        ])
        .interpolate(interpolateHcl);
    },
    getThoseInRegionsWithNoLP() {
      return _.countBy(this.filteredDataNoLP.map(value => value["region"]));
    },
    percentageDataMap() {
      const map = new Map();
      this.getRegionData.forEach(d => {
        const value = d.value
          ? this.showLikelyhood
            ? d.value / (d.value + this.getThoseInRegionsWithNoLP[d.key])
            : d.value / this.filteredCount
          : 0;
        map.set(d.key, {
          key: d.key,
          label: this.$t(`filters.demographics.region.options.${d.key}`),
          value,
          formated: value ? format(".0%")(value) : "",
          color: this.showLikelyhood
            ? this.color(value * 5)
            : this.color(value * 10)
        });
      });
      return map;
    },
    simplified() {
      return this.chartWidth < this.chartMaxWidth;
    }
  },
  watch: {
    breakpoint() {
      this.onResize();
    }
  },
  methods: {
    onResize() {
      this.chartWidth = Math.min(
        this.$refs.svg.clientWidth,
        this.chartMaxWidth
      );
    }
  }
};
</script>

<style scoped>
.path {
  stroke: #fff;
}
</style>